<template>
  <div class="modal fade" :id="'kt_modal_' + id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="updateCategory" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('categories.modification') }}</h5>

            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">

              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <div class="row">
              <Input
                  containerClass="col-12 mt-auto mb-5"
                  :name="`${id}-name`"
                  type="text"
                  :label="$t('categories.name')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true" size="lg"
                  :placeholder="$t('categories.name_placeholder')"
                  v-model="formData.name"
              />

              <Select2
                  containerClass="col-12 mt-auto mb-5"
                  :name="`${id}-type-categories`"
                  :multiple="false"
                  :label="$t('categories.categoriesType')"
                  labelClass="d-flex align-items-center fs-6 fw-bold mb-2"
                  selectClass="form-select form-select-solid"
                  :isRequired="false"
                  :placeholderText="$t('categories.categoriesType_placeholder')"
                  v-model="formData.parent_type"
              >
                <option v-for="categoryType in categoriesType" :key="categoryType.value" :value="categoryType.value">
                  {{ categoryType[locale] }}
                </option>
              </Select2>

              <Select2
                  containerClass="col-12 mt-auto mb-5"
                  :name="`${id}-sub-categories`"
                  :multiple="false"
                  :label="$t('categories.categoriesParent')"
                  labelClass="d-flex align-items-center fs-6 fw-bold mb-2"
                  selectClass="form-select form-select-solid"
                  :isRequired="false"
                  :placeholderText="$t('categories.categoriesParent_placeholder')"
                  v-model="formData.parent_id"
              >
                <option v-for="category in allCategories" :key="category.id" :value="category.id">
                  {{ category.name }}
                </option>
              </Select2>
            </div>


          </div>
          <div class="modal-footer">
            <Button btn-class="btn-sm me-2" type="cancel" btn-text="button.close" size="7px 30px" @click="closeModal"/>
            <Button btn-class="btn-sm" type="submit" btn-text="button.save" size="7px 30px" :isLoading="processing"/>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

import {ref, defineEmits, defineProps, computed, onMounted, watch} from "vue";
import Select2 from "@/components/Select2.vue";
import Input from "@/components/Input.vue";
import {useLocales} from "@/composables/locales";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText.vue"
import Button from "@/components/Button.vue"

const store = useStore()
const {locale} = useLocales()
const emit = defineEmits(['reloadDatatable'])

const props = defineProps({
  id: {
    type: String,
    default: 'kt_modal_'
  },
  editForm : {
    type: Object,
    default: () => ({
      id: null,
      name: '',
      parent_id: null,
      parent_type: '',
    })
  },


})


const processing = ref(false)
const formData = ref(props.editForm)
const categories = computed(() => store.getters['qvctCategories/getQvctCategories'])
const categoriesType = computed(() => store.getters['qvctCategories/getQvctCategoriesType'])


function flattenCategories(categories, parentPath = '', parentName = null) {
  let result = [];

  (categories || []).forEach(category => {
    if (!category || !category.name) return; // sécurité

    const fullPath = parentPath ? `${parentPath} > ${category.name}` : category.name;

    result.push({
      id: category.id,
      name: category.name,
      parent_id: category.parent_id ?? null,
      parent_name: parentName,
      full_path: fullPath,
      type: category.parent_type?.fr ?? null,
    });

    if (Array.isArray(category.children) && category.children.length > 0) {
      result = result.concat(flattenCategories(category.children, fullPath, category.name));
    }
  });

  return result;
}

const allCategories = computed(() => {
  if (!categories.value) return [];

  return flattenCategories(categories.value);
})

function closeModal(){
  $("#kt_modal_" + props.id).modal('hide')
}



function updateCategory() {
  processing.value = true

  store.dispatch('qvctCategories/updateQvctCategorie', formData.value)
      .then(res => {
        loadData()
        $('#'+props.id).modal('toggle')
        window.toastr['success'](i18n.global.t("notification.category_updated"))
        emit('reloadDatatable')
        closeModal()
      })
      .finally(() => processing.value = false)
}

function loadData() {
  Promise.all([
    store.dispatch('qvctCategories/loadQvctCategorie'),
    store.dispatch('qvctCategories/loadQvctCategorieType'),
  ])
}

onMounted(() => {
  loadData()
})


</script>

<style scoped></style>
